import Button from 'components/Button';
import { ICustomModalButtonsProps } from 'interfaces/components/customModal';

const CustomModalButtons = ({
  disabled,
  onClose,
  handleApply,
  firstBtnLabel,
  firstBtnId,
  containerClassName
}: ICustomModalButtonsProps) => {
  return (
    <div className={`flex flex-col gap-6 ${containerClassName}`}>
      <Button
        id={firstBtnId}
        label={firstBtnLabel}
        onClick={handleApply}
        className='py-[9px] rounded-5xl bg-green-500 text-[18px] leading-[19.2px] font-light text-center disabled:bg-gray-500 disabled:cursor-not-allowed disabled:text-white hover:bg-[#62c77d] transition-all duration-300'
        disabled={disabled}
      />
      <Button
        id='back_button'
        label='Back'
        onClick={onClose}
        className='text-lg font-light text-center text-black dark:text-white'
      />
    </div>
  );
};

export default CustomModalButtons;
